// Dependencias.
import Vue from 'vue';

// Estado inicial
const initialState = () => ({
  customers: [],
  total: 0,
  loadingState: false,
});

// Objeto de estado
const state = initialState();

// Getters
const getters = {
  getCustomerList(state) {
    return state.customers;
  },

  getCustomersListToSelectInput(state) {
    return state.customers.map(customer => ({
      usuario: customer.usuario,
      descricao: customer.descricao,
      permissoes: customer.permissoes,
    }));
  },

  getTotal(state) {
    return state.total;
  },

  getLoadingState(state) {
    return state.loadingState;
  },
};

// Ações
const actions = {
  clearState({ commit }) {
    commit('RESET');
  },
  createCustomer({ commit }, { usuario, senha, descricao, permissoes, supervisores, tokenJWT2FA }) {
    return new Promise(async resolve => {
      const api = new Vue.prototype.$httpClient();
      const url = `/logins`;
      commit('setLoadingState', true);
      const response = await api.send(
        url,
        'POST',
        {
          usuario: usuario,
          senha: senha,
          descricao: descricao,
          permissoes: permissoes,
          supervisores: supervisores || [],
          tokenJWT2FA: tokenJWT2FA,
        },
        undefined,
        false
      );
      commit('setLoadingState', false);
      if (response.status == 200 || response.status == 201) {
        resolve({
          status: 200,
          msg: 'Cliente incluído com sucesso.',
        });
      } else {
        resolve({
          status: response.status,
          msg: response.data.mensagem || 'Ocorreu um erro desconhecido durante sua requisição.',
        });
      }
    });
  },
  convidarUsuario({ commit }, { usuario, descricao, supervisores, tokenJWT2FA }) {
    return new Promise(async (resolve) => {
      const api = new Vue.prototype.$httpClient();
      const url = `/logins/convidar`;
      commit('setLoadingState', true);
      const response = await api.send(
        url,
        'POST',
        {
          usuario,
          descricao,
          supervisores: supervisores || [],
          tokenJWT2FA,
        },
        undefined,
        false,
      );
      commit('setLoadingState', false);

      if (response.status === 201 || response.status === 200) {
        resolve({
          status: 201,
          msg: response.data.mensagem || 'Convite criado com sucesso.',
          dados: response.data.dados,
        });
      } else {
        resolve({
          status: response.status,
          msg: response.data.mensagem || 'Ocorreu um erro desconhecido durante sua requisição.',
        });
      }
    });
  },
  reenviarConvite({ commit }, { id, tokenJWT2FA }) {
    return new Promise(async (resolve) => {
      const api = new Vue.prototype.$httpClient();
      const url = `/logins/${id}/reenviar-convite`;
      commit('setLoadingState', true);
      const response = await api.send(
        url,
        'POST',
        { tokenJWT2FA },
        undefined,
        false,
      );
      commit('setLoadingState', false);

      if (response.status === 200) {
        resolve({
          status: 200,
          msg: response.data.mensagem || 'Convite reenviado com sucesso.',
          dados: response.data.dados,
        });
      } else {
        resolve({
          status: response.status,
          msg: response.data.mensagem || 'Ocorreu um erro desconhecido durante sua requisição.',
        });
      }
    });
  },
  fetchCustomers({ commit }) {
    return new Promise(async resolve => {
      const api = new Vue.prototype.$httpClient();
      const url = `/logins`;
      commit('setLoadingState', true);
      const response = await api.send(url, 'GET', null, undefined, false);
      commit('setLoadingState', false);
      if (response.status == 200) {
        commit('setCustomers', response.data.dados);
        commit('setTotal', response.data.dados.length);
        resolve({
          status: 200,
          msg: 'Lista de usuários recuperada.',
        });
      } else {
        commit('setCustomers', []);
        commit('setTotal', 0);
        resolve({
          status: response.status,
          msg: response.data.mensagem || 'Ocorreu um erro desconhecido durante sua requisição.',
        });
      }
    });
  },
  updateCustomer({ commit }, { id, name, identifier, cnpjCpf, city, state, description, logo, statusCustomer }) {
    return new Promise(async resolve => {
      const api = new Vue.prototype.$httpClient();
      const url = `/logins`;
      commit('setLoadingState', true);
      const response = await api.send(
        url,
        'PUT',
        {
          id: id,
          nome: name,
          identificacao: identifier,
          cnpjCpf: cnpjCpf,
          uf: state,
          cidade: city,
          descricao: description,
          logotipo: logo,
          statusCliente: statusCustomer
        },
        undefined,
        false
      );
      commit('setLoadingState', false);
      if (response.status == 200) {
        resolve({
          status: 200,
          msg: 'Cliente atualizado com sucesso.',
        });
      } else {
        resolve({
          status: response.status,
          msg: response.data.mensagem || 'Ocorreu um erro desconhecido durante sua requisição.',
        });
      }
    });
  },
  updateUser({ commit }, { id, usuario, senha, descricao, permissoes, supervisores, tokenJWT2FA }) {
    return new Promise(async resolve => {
      const api = new Vue.prototype.$httpClient();
      const url = `/logins`;
      commit('setLoadingState', true);
      
      const payload = {
        id: id,
        usuario: usuario,
        descricao: descricao,
        permissoes: permissoes,
        supervisores: supervisores || [],
        tokenJWT2FA: tokenJWT2FA,
      };
      
      if (senha && senha.trim() !== '') {
        payload.senha = senha;
      }
      
      const response = await api.send(url, 'PUT', payload, undefined, false);
      commit('setLoadingState', false);
      if (response.status == 200) {
        resolve({
          status: 200,
          msg: 'Usuário atualizado com sucesso.',
        });
      } else {
        resolve({
          status: response.status,
          msg: response.data.mensagem || 'Ocorreu um erro desconhecido durante sua requisição.',
        });
      }
    });
  },
  deleteUser({ commit }, { id, tokenJWT2FA }) {
    return new Promise(async resolve => {
      const api = new Vue.prototype.$httpClient();
      const query = tokenJWT2FA
        ? `?tokenJWT2FA=${encodeURIComponent(tokenJWT2FA)}`
        : '';
      const url = `/logins/${id}${query}`;
      commit('setLoadingState', true);
      const response = await api.send(url, 'DELETE', null, undefined, false);
      commit('setLoadingState', false);
      if (response.status == 200) {
        resolve({
          status: 200,
          msg: 'Usuário excluído com sucesso.',
        });
      } else {
        resolve({
          status: response.status,
          msg: response.data.mensagem || 'Ocorreu um erro desconhecido durante sua requisição.',
        });
      }
    });
  },
  autenticationUser({ commit }, { usuario, senha, codigoTOTP}) {
    return new Promise(async resolve => {
      const api = new Vue.prototype.$httpClient();
      const url = `/login`;
      commit('setLoadingState', true);
      const response = await api.send(
        url,
        'POST',
        {
          usuario: usuario,
          senha: senha,
          codigoTOTP: codigoTOTP
        },
        undefined,
        false
      );
      commit('setLoadingState', false);
      if (response.status == 200) {
        resolve({
          status: 200,
          msg: 'Usuário autenticado com sucesso.',
          retorno: response.data,
        });
      } else {
        resolve({
          status: response.status,
          msg: response.data.mensagem || 'Ocorreu um erro desconhecido durante sua requisição.',
        });
      }
    });
  },
  fetchTemplatesForPermissions({ commit }) {
    return new Promise(async resolve => {
      const api = new Vue.prototype.$httpClient();
      const url = `/templates`;
      const response = await api.send(url, 'GET', null, undefined, false);
      if (response.status == 200) {
        resolve({
          status: 200,
          msg: 'Templates recuperados com sucesso.',
          data: response.data.dados || [],
        });
      } else {
        resolve({
          status: response.status,
          msg: response.data.mensagem || 'Erro ao buscar templates.',
          data: [],
        });
      }
    });
  },
};

// Mutações
const mutations = {
  RESET(state) {
    const newState = initialState();
    Object.keys(newState).forEach(key => {
      state[key] = newState[key];
    });
  },
  setCustomers(state, data) {
    state.customers = data;
  },
  setTotal(state, data) {
    state.total = data;
  },
  setLoadingState(state, data) {
    state.loadingState = data;
  },
};

// Exoprtanto módulo
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
